import SuraasaPlus from "./assets/suraasaPlus.webp"

export enum SubscriptionSlugs {
  SuraasaPlusMonthly = "suraasa-plus",
  SuraasaPlusYearly = "w4m3-suraasa-plus",
  SuraasaPlusNewYear = "suraasa-plus-new-year-2026",
}

export enum SubscriptionType {
  monthly,
  yearly,
}

export const getLogoSrc = (productSlug: SubscriptionSlugs): string => {
  switch (productSlug) {
    case SubscriptionSlugs.SuraasaPlusMonthly:
    case SubscriptionSlugs.SuraasaPlusYearly:
    case SubscriptionSlugs.SuraasaPlusNewYear:
      return SuraasaPlus
  }
}

export const getSubscriptionRenewDurationType = (
  productSlug: SubscriptionSlugs
): SubscriptionType | undefined => {
  switch (productSlug) {
    case SubscriptionSlugs.SuraasaPlusMonthly:
      return SubscriptionType.monthly

    case SubscriptionSlugs.SuraasaPlusYearly:
      return SubscriptionType.yearly

    case SubscriptionSlugs.SuraasaPlusNewYear:
      return undefined
  }
}
